import { request } from './request';

export const getAllTeleconsultations = (
  page = 1,
  filterString = '',
  limit = 50,
) => request(`teleconsultations?page=${page}${filterString}&limit=${limit}`);

export const getTeleconsultationById = (id) =>
  request(`teleconsultations/${id}`);

export const updateTeleconsultation = (id, body, { showMessage } = {}) =>
  request(`teleconsultations/${id}`, {
    method: 'PATCH',
    body,
  });

export const deleteTeleconsultation = (id, body) =>
  request(
    `teleconsultations/${id}`,
    {
      method: 'DELETE',
      body,
    },
    'Tele deleted successfully!',
  );
